/**
 * @desc 创建三方仓工厂仓盘点单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InventoryThireFactoryRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/createThireFactoryInventory`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
